import axios, {AxiosResponse} from "axios";
import {AxiosError} from "axios";
import {otherError} from "../../lang";

export async function sendGet(url: string, data: any, onError: (arg0: string) => void): Promise<AxiosResponse> {
    let search = new URLSearchParams(window.location.search);
    for (let key in data) {
        if (data.hasOwnProperty(key)) {
            search.append(key, data[key]);
        }
    }

    return await sendRequest(
        async () => await axios.get(url + '?' + search.toString()),
        onError
    );
}

export async function sendPost(url: string, data: any, onError: (arg0: string) => void): Promise<AxiosResponse> {
    return await sendRequest(
        async () => await axios.post(
          url,
          data
        ),
        onError
    );
}


async function delay(time: number): Promise<number>
{
    return new Promise<number>((resolve) => setTimeout(resolve, time))
}

export async function sendRequest(fn: () => Promise<any>, onError: (arg0: string) => void) {
    // return await fn()
    while (1) {
        try {
            const data = await fn();

            if (data.status !== 200) {
                onError('Возникла проблема в работе приложения.');
                return false
            } else {
                let dataParsed = data.data;
                if (dataParsed.status === 'error') {
                    onError(dataParsed.message);
                    return false
                } else {
                    return data;
                }
            }
        } catch (e: any) {
            if (e.message === 'Network Error') {
                await delay(500)
                continue
            }

            onError('Возникли проблемы с сетью. Для работы приложения нужно интернет-соединение.');
            return false
        }
    }
}

export async function proceedThunk(call: any, props: any) {
    try {
        let ttl = props.ttl ?? 3
        const response: AxiosResponse = await call()
        if (response.status === 200) {
            return response.data
        }
        if (typeof ttl !== 'undefined' && ttl > 0) {
            const newProps = Object.assign(props, {ttl: ttl--})
            window.setTimeout(() => proceedThunk(call, newProps), 1000)
        }
    } catch (err) {
        if (err instanceof AxiosError) {
            const returnMsg = err.response?.data.error ?? err.response?.status
            throw new Error(returnMsg)
        } else {
            throw new Error(otherError)
        }
    }
}
